import { injectable } from 'inversify';
import { EventStreamListener } from '@/app/event-stream/event-stream-listener';
import { ObjectEvent, ObjectCompletedEventName } from '../events/object-completion-events';
import objectCompletionStoreModule from '../state/object-completion-state';

@injectable()
export class SetObjectCompleted implements EventStreamListener {
  public get events(): string[] {
    return [
      ObjectCompletedEventName
    ];
  }

  public handle(event: ObjectEvent): void {
    objectCompletionStoreModule.setObjectCompleted(event.payload.id);
  }
}
